import { useMemo } from 'react';
import { Chip, Box } from "@mui/joy";
import { Link, useParams } from "react-router-dom";
import { capitalizeFirstLetter } from '@/utils/strings';
import { EmojiDisplay } from '@/components/EmojiDisplay';
import { useGetTagsQuery } from '../api';

export function TagsList({ tags, size = "sm", variant = "soft", color = "primary", gap = 0.5, clickable = true }) {
  const { householdId } = useParams();
  const { data } = useGetTagsQuery({ householdId }, { skip: !householdId });

  const emojiByName = useMemo(() => {
    const entries = (data?.data || []).map(t => [t.name, t.emoji]);
    return Object.fromEntries(entries);
  }, [data]);

  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap, flexWrap: 'wrap' }}>
      {tags.map(tag => (
        <TagChip key={tag} tag={tag} emoji={emojiByName[tag]} size={size} variant={variant} color={color} clickable={clickable} />
      ))}
    </Box>
  );
}

function TagChip({ tag, emoji, size, variant, color, clickable }) {
  const { householdId } = useParams();

  const chip = (
    <Chip
      size={size}
      variant={variant}
      color={color}
      startDecorator={emoji ? <EmojiDisplay emoji={emoji} size={14} /> : undefined}
      sx={{ '&:hover': { backgroundColor: clickable ? 'primary.200' : 'default' } }}
    >
      {capitalizeFirstLetter(tag)}
    </Chip>
  );

  if (householdId && clickable) {
    return (
      <Link to={`/h/${householdId}/recipes?tag=${encodeURIComponent(tag)}`} style={{ textDecoration: 'none' }}>{chip}</Link>
    );
  }
  return chip;
}
